import { render } from "./v-error.vue?vue&type=template&id=835700fc&scoped=true"
import script from "./v-error.vue?vue&type=script&lang=js"
export * from "./v-error.vue?vue&type=script&lang=js"

import "./v-error.vue?vue&type=style&index=0&id=835700fc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-835700fc"]])

export default __exports__